import { Tabs } from 'antd';
import { useParams } from 'react-router-dom';
import ViolationsTab from './ViolationsTab';
import NotificationsTab from './NotificationsTab';
import GlobalNotifications from './GlobalNotifications';
import Alerts from './Alerts';
import IdleTrucksAlertsTab from './IdleTrucksAlertsTab';
import RedZoneAlertsTab from './RedZoneAlertsTab';
import { hasRteAccess, useProjectData } from '../../../../../../../../Hooks/useProjectData';
import { cameraEnabled } from '../../../../../../../../Utils/cameraEnabled';
import { isWhiteLabelAdmin } from '../../../../../../../../Utils/whiteLabel';

type Params = {
  readonly id: string;
};

const NotificationCompany = () => {
  const { id } = useParams<Params>();
  const { projectData } = useProjectData();
  const isWhiteLabel = isWhiteLabelAdmin();

  const enabledCamera = cameraEnabled(projectData?.projectName);

  const items = [
    {
      key: '1',
      label: 'Violations',
      children: <ViolationsTab companyId={id} />,
    },
    {
      key: '2',
      label: 'Notifications',
      children: <NotificationsTab companyId={id} />,
    },
    {
      key: '3',
      label: 'Global Notifications',
      children: <GlobalNotifications companyId={id} />,
    },
    {
      key: '4',
      label: 'Idle Trucks Alerts (3 Days)',
      children: <IdleTrucksAlertsTab companyId={id} />,
    },
    ...(enabledCamera
      ? [
          {
            key: '5',
            label: 'Camera Alerts',
            children: <Alerts companyId={id} />,
          },
        ]
      : []),
    {
      key: '6',
      label: 'Red Zone Alerts',
      children: <RedZoneAlertsTab companyId={id} />,
    },
  ];

  const isRte = hasRteAccess(projectData?.projectName);

  const filteredItems = items.filter((item) => {
    if (isWhiteLabel && item.label === 'Global Notifications') {
      return false;
    }
    if (isWhiteLabel && item.label === 'Camera Alerts' && !isRte) {
      return false;
    }
    return true;
  });

  return (
    <div className="mainPage">
      <Tabs items={filteredItems} />
    </div>
  );
};

export default NotificationCompany;
